<template>
  <b-row>
    <b-col>
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading :module-id="access.module_id" :profile-id="access.profile_id" :reference="access.view_reference" summary-only />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }" v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" @click="filtersOpen = !filtersOpen"><AppIcon name="filter" :fill="filtersOpen" /></b-button>
            </div>
          </div>
        </section>
        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width: 150px;"><label class="filter-label">Desde</label><b-form-input type="date" size="sm" v-model="filters.date_start" /></div>
            <div class="list-view-filter" style="width: 150px;"><label class="filter-label">Hasta</label><b-form-input type="date" size="sm" v-model="filters.date_end" /></div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;"><label class="filter-label">Punto de venta</label><v-select :options="arr.filters.points_sales" v-model="filters.points_sales" :multiple="false" :select-on-tab="true" /></div>
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 300px;"><label class="filter-label">Proveedores</label><v-select :options="arr.filters.suppliers" v-model="filters.suppliers" :multiple="true" :select-on-tab="true" /></div>
            <b-button variant="outline-dark" size="sm" @click="filterTab" :disabled="table.preload || pivot.preload" v-b-tooltip.hover title="Aplicar filtros" style="height:31px;width:31px;padding:0;flex-shrink:0;"><AppIcon name="filter" /></b-button>
          </div>
        </b-collapse>
      </b-card>
      
      <b-card no-body class="mb-3">
      <b-tabs>
        <b-tab title="IVA Compras" @click="setTabActive('iva')">
          <div v-if="table.items.length && !table.preload" class="purchase-reports-toolbar">
              <div class="purchase-reports-toolbar__summary"><AppIcon name="receipt_long" /><span>IVA Compras</span><small>{{ table.items.length }} comprobantes</small></div>
              <div class="purchase-reports-toolbar__actions">
              <b-dropdown right size="sm" variant="link" boundary="window" toggle-class="list-view-ghost-btn" no-caret>
                <template #button-content><AppIcon name="view_column" class="mr-1" />Columnas<AppIcon name="chevron-down" class="ml-1" /></template>
                <b-dropdown-form class="purchase-reports-columns-menu" @click.stop>
                  <div class="purchase-reports-columns-menu__title">Columnas visibles</div>
                  <b-form-checkbox v-for="column in ivaColumnOptions" :key="column.key" v-model="filters.iva_columns" :value="column.key" @change="onIvaColumnsChange">{{ column.label }}</b-form-checkbox>
                </b-dropdown-form>
              </b-dropdown>
              <b-button size="sm" variant="link" class="list-view-ghost-btn" @click="printIvaPurchase"><AppIcon name="print" class="mr-1" />Imprimir PDF</b-button>
              <b-dropdown right size="sm" variant="link" boundary="window" toggle-class="list-view-ghost-btn" no-caret>
                <template #button-content><AppIcon name="download" class="mr-1" />Exportar<AppIcon name="chevron-down" class="ml-1" /></template>
                <b-dropdown-item>
                  <export-excel
                      :data = "arr.export"
                      worksheet = "IVA Compras"
                      name = "taxes-purchase.xls">
                      <AppIcon name="file-earmark-spreadsheet" class="mr-1" />Excel
                  </export-excel>
                </b-dropdown-item>
                <b-dropdown-item @click="exportFormatIvaDigital()">
                  <AppIcon name="file-earmark-text" class="mr-1" />Libro IVA Compras Digital
                </b-dropdown-item>
              </b-dropdown>
              </div>
          </div>
          
          <b-row>
            <b-col sm="12" v-if="table.items.length && !table.preload && !table.init">
              <Grid 
                ref="ivaGrid"
                :columns="grid.iva.columns"
                :dataRow="table.items"
                :dataTotal="grid.iva.totales"
                :columnState="ivaGridColumnState"
                :rowHeight="45"
                :gridHeight="'80vh'"
                @column-state-change="saveIvaGridState"
              />
            </b-col>            
          </b-row>
              
          <div class="text-center" v-if="table.preload && !table.init">
            <b-spinner label="Spinning"></b-spinner>
          </div>
          
          <EmptyState v-if="!table.items.length && !table.preload && !table.init" icon="receipt_long" title="No se encontraron registros" />
          <EmptyState v-if="!table.items.length && table.init" icon="filter" title="Configurá los filtros para obtener datos" />
        </b-tab>  
        <b-tab title="Compras" @click="loadByFilterReport" :disabled="table.preload">
          <DynamicSummary v-if="!pivot.init" storage-key="dynamic_summary_purchase_reports" :dimensions="report.dimensions" :default-groups="report.defaultGroups" :load-report="loadReport" quantity-label="Comprobantes" @error="showReportError" />
          <EmptyState v-if="pivot.init" icon="filter" title="Configurá los filtros para obtener datos" />
        </b-tab>
      </b-tabs>
      </b-card>
      <Printer v-if="crud.print.filters" :filters="crud.print.filters" :reference="crud.print.reference" :key="crud.print.key" />

      <b-card body-class="py-2">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <AppIcon name="back" class="mr-1" />
              Volver
            </b-button>                        
          </b-col>          
        </b-row>
      </b-card>
    
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import moment from 'moment'
  import Storage from '@/handler/storageSession'
  import DynamicSummary from '@/components/inc/reporting/DynamicSummary'
  import Grid from '@/components/inc/agGrid/index'
  import StorageLocal from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
  import Printer from '@/components/inc/printer/printer'

  export default {
    components: {      
      Grid,
      DynamicSummary,
      TabHeaderActions,
      Printer,
    },    
    data: () => {
      return {      
        access: {
          module_id: Modules.COMPRAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'reports',
          elements: {}
        },  
        table : {
          items: [],          
          filter: null,
          preload: false,
          init: true,
        },
        filtersOpen: false,
        crud: { print: { key: 0, filters: null, reference: 'purchase-iva' } },
        ivaColumnsConfigured: false,
        ivaGridColumnState: [],
        pivot: { preload: false, init: true },
        report: {
          defaultGroups: ['year', 'month'],
          dimensions: [
            { key: 'year', label: 'Año' }, { key: 'month', label: 'Mes' }, { key: 'supplier', label: 'Proveedor' }, { key: 'category', label: 'Categoría' }, { key: 'point_sale_imputation', label: 'Punto de venta imputación' },
          ],
        },
        tabs: { iva: true, report: false },
        grid: {
          iva: {
            columns: [],
            totales: [],
          }          
        },        
        arr: {
          filters : {
            suppliers: [],
            points_sales: [],
          },
          columns : {
            iva_conditions: [],
            perceptions: [],
          },
          purchases: []
        },
        filters: {
          date_start: '',
          date_end: '',
          suppliers: null,
          points_sales: null,
          paginate: false,
          iva_columns: ['business', 'voucher', 'date', 'date_expiration', 'date_imputation', 'supplier', 'amount_net', 'amount_total'],
        },
        totals: {
          total: 0,
          total_net: 0,
        }
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {
      this.filterLoad()
      this.filtersOpen = StorageLocal.getValue('filters_open_purchase_reports') === 'true'
    },
    watch: {
      filtersOpen(value) {
        StorageLocal.setValue('filters_open_purchase_reports', value ? 'true' : 'false')
      }
    },
    computed: {
      // CONFIGURACION      
      getCurrency() {
        return 'ARS'
      },
      ivaColumnOptions() {
        return [
          { key: 'business', label: 'Empresa' }, { key: 'voucher', label: 'Comprobante' }, { key: 'date', label: 'Fecha' }, { key: 'date_expiration', label: 'Vencimiento' }, { key: 'date_imputation', label: 'Imputación' }, { key: 'supplier', label: 'Proveedor' }, { key: 'amount_net', label: 'Neto' },
          ...this.arr.columns.iva_conditions.map(item => ({ key: 'iva_' + item.code, label: item.label })),
          ...this.arr.columns.perceptions.map(item => ({ key: 'perception_' + item.afip_reference, label: item.label })),
          { key: 'amount_total', label: 'Total' },
        ]
      },
    },  
    methods: {
      isIvaColumnVisible(key) { return this.filters.iva_columns.indexOf(key) !== -1 },
      getIvaGridField(key) {
        if(key === 'business') return 'points_sales.business.reference'
        if(key.indexOf('iva_') === 0) {
          const iva = this.arr.columns.iva_conditions.find(item => 'iva_' + item.code === key)
          return iva ? 'amount_iva_' + iva.label : key
        }
        if(key.indexOf('perception_') === 0) return 'perc_' + key.replace('perception_', '')
        return key
      },
      onIvaColumnsChange() {
        this.saveFilterStorage()
        this.$nextTick(() => {
          const grid = this.$refs.ivaGrid
          if(!grid) return
          this.ivaColumnOptions.forEach(column => grid.setColumnVisibility(this.getIvaGridField(column.key), this.isIvaColumnVisible(column.key)))
          this.saveIvaGridState(grid.getColumnState())
        })
      },
      saveIvaGridState(state) {
        if(!Array.isArray(state)) return
        const fields = {}
        this.ivaColumnOptions.forEach(column => { fields[this.getIvaGridField(column.key)] = column.key })
        const gridState = state.filter(column => fields[column.colId]).map(column => ({ colId: column.colId, width: column.width, hide: column.hide }))
        this.ivaGridColumnState = gridState
        this.filters.iva_columns = gridState.filter(column => !column.hide).map(column => fields[column.colId])
        this.ivaColumnsConfigured = true
        this.saveFilterStorage()
        StorageLocal.setValue('purchase_reports_iva_grid', JSON.stringify({ columns: this.filters.iva_columns, state: gridState }))
      },
      restoreIvaGridPreferences() {
        const value = StorageLocal.getValue('purchase_reports_iva_grid')
        if(!value) return
        try {
          const preferences = JSON.parse(value)
          if(Array.isArray(preferences.columns)) { this.filters.iva_columns = preferences.columns; this.ivaColumnsConfigured = true }
          if(Array.isArray(preferences.state)) this.ivaGridColumnState = preferences.state
        } catch (error) {
          StorageLocal.removeValue('purchase_reports_iva_grid')
        }
      },
      printIvaPurchase() {
        this.crud.print.key = Math.random()
        this.crud.print.filters = Object.assign({}, this.filters, { point_sale_label: this.filters.points_sales ? this.filters.points_sales.label : 'Todos los puntos de venta' })
      },
      filterTab() {
        if(this.tabs.iva) this.loadByFilter()
        else this.loadByFilterReport()
      },
      setTabActive(type) {
        this.tabs.iva = type === 'iva'
        this.tabs.report = type === 'report'
      },
      loadByFilterReport() {
        this.pivot.init = false
        this.pivot.preload = false
        this.setTabActive('report')
      },
      loadReport(params) {
        return serviceAPI.filtrarReportPurchaseSummary(Object.assign({}, this.filters, params))
      },
      showReportError(error) {
        this.$awn.alert(Error.showError(error))
      },
      filterLoad() {
        this.filterLoadSuppliers()
        this.filterLoadPointSale()
        this.filters.date_start = moment().subtract(30, 'days').format('YYYY-MM-DD') 
        this.filters.date_end = moment().format('YYYY-MM-DD') 
        this.restoreFilterStorage() 
        this.restoreIvaGridPreferences()
        return Promise.all([this.getIvaConditions(), this.getPerceptions()]).then(() => this.loadByFilter())
      },
      filterLoadSuppliers() {
        var result = serviceAPI.obtenerProveedores()        
        result.then((response) => {
          var data = response.data    

          this.arr.filters.suppliers = []
          data.forEach(element => {            
            this.arr.filters.suppliers.push({ code: element.id, label: element.name })            
          });          
        })   
      },
      filterLoadPointSale() {
        var result = serviceAPI.obtenerPuntosVentas()        
        result.then((response) => {
          var data = response.data    

          this.arr.filters.points_sales = []
          data.forEach(element => {                            
            this.arr.filters.points_sales.push({ code: element.id, label: element.full_identification })            
          });          
        })   
      },
      getIvaConditions() {
        var result = serviceAPI.obtenerIvaCondition()
        return result.then((response) => {
          var data = response.data    

          data.forEach(element => {            
            this.arr.columns.iva_conditions.push({ code: element.id, label: element.name, total_net: 0, total_iva: 0 })
          });
          this.arr.columns.iva_conditions.forEach(item => {
            const key = 'iva_' + item.code
            if(!this.ivaColumnsConfigured && this.filters.iva_columns.indexOf(key) === -1) this.filters.iva_columns.push(key)
          })
        })
      },
      getPerceptions() {
        var result = serviceAPI.obtenerPercepciones()
        return result.then((response) => {
          var data = response.data

          data.forEach(element => {            
            this.arr.columns.perceptions.push({ code: element.id, label: element.name, afip_reference: element.afip_reference, total: 0 })
          });
          this.arr.columns.perceptions.forEach(item => {
            const key = 'perception_' + item.afip_reference
            if(!this.ivaColumnsConfigured && this.filters.iva_columns.indexOf(key) === -1) this.filters.iva_columns.push(key)
          })
        })   
      },
      loadByFilter() {
        this.saveFilterStorage()

        this.table.init = false
        this.table.preload = true

        this.totals.total_net = 0
        this.totals.total = 0

        this.arr.columns.iva_conditions.forEach(elementIva => {
          elementIva.total_net = 0,
          elementIva.total_iva = 0
        });

        this.arr.columns.perceptions.forEach(elementPerceptions => {
          elementPerceptions.total = 0
        });

        var result = serviceAPI.filtrarComprobante(this.filters)

        result.then((response) => {          
          var data = response.data          
          this.table.items = data          

          data.forEach(element => {
            // PREPARAR IVA FISCAL
            if(element.net.length){
              element['amount_net'] = 0
            }            
            this.arr.columns.iva_conditions.forEach(elementIva => {
              element['amount_iva_' + elementIva.label] = 0      
              element['amount_net_' + elementIva.label] = 0 
            
              if(element.net.length){
                element.net.forEach(elementNet => {
                  if(elementNet.iva_conditions_id == elementIva.code){
                    if(elementNet.amount_iva > 0){
                      element['amount_iva_' + elementIva.label] = element['amount_iva_' + elementIva.label] + parseFloat(elementNet.amount_iva)
                      element['amount_net_' + elementIva.label] = element['amount_net_' + elementIva.label] + parseFloat(elementNet.amount_net)
                      element['amount_net'] = element['amount_net'] + parseFloat(elementNet.amount_net)
                                   
                      if(element.type_voucher.type_balance == '-'){  
                        elementIva.total_iva = elementIva.total_iva - parseFloat(elementNet.amount_iva)
                      } else {
                        elementIva.total_iva = elementIva.total_iva + parseFloat(elementNet.amount_iva)
                      }

                      if(element.type_voucher.type_balance == '-'){
                        this.totals.total_net = this.totals.total_net - parseFloat(elementNet.amount_net)
                      } else {
                        this.totals.total_net = this.totals.total_net + parseFloat(elementNet.amount_net)
                      }
                    } else {
                      element['amount_iva_' + elementIva.label] = element['amount_iva_' + elementIva.label] + parseFloat(elementNet.amount_net)

                      if(element.type_voucher.type_balance == '-'){
                        elementIva.total_net = elementIva.total_net - parseFloat(elementNet.amount_net)
                      } else {
                        elementIva.total_net = elementIva.total_net + parseFloat(elementNet.amount_net)
                      }
                    }
                  }
                });
              }
            });
            if(!element.net.length){
              this.totals.total_net = this.totals.total_net + parseFloat(element.amount_net)
            }

            // PREPARAR PERCERPCIONES
            for(const key in this.arr.columns.perceptions) {              
              if(!element['perc_' + this.arr.columns.perceptions[key].afip_reference]) {
                element['perc_' + this.arr.columns.perceptions[key].afip_reference] = 0
              }              
            }
            element.perceptions.forEach(elementPerceptions => {                            
              if(!element['perc_' + elementPerceptions.perception.afip_reference]) {
                element['perc_' + elementPerceptions.perception.afip_reference] = 0
              }

              if(element.type_voucher.type_balance == '-'){                
                element['perc_' + elementPerceptions.perception.afip_reference] = element['perc_' + elementPerceptions.perception.afip_reference] - parseFloat(elementPerceptions.amount_total)
                let obj = this.arr.columns.perceptions.find(obj => obj.code === elementPerceptions.perceptions_id);                
                if(obj) {
                  obj.total = obj.total - parseFloat(elementPerceptions.amount_total);
                }
              } else {                
                element['perc_' + elementPerceptions.perception.afip_reference] = element['perc_' + elementPerceptions.perception.afip_reference] + parseFloat(elementPerceptions.amount_total)
                let obj = this.arr.columns.perceptions.find(obj => obj.code === elementPerceptions.perceptions_id);                
                if(obj) {
                  obj.total = obj.total + parseFloat(elementPerceptions.amount_total);
                }                
              }
            });                   

            // TOTALES
            if(element.type_voucher.type_balance == '-'){
              this.totals.total = this.totals.total - parseFloat(element.amount_total)
            } else {
              this.totals.total = this.totals.total + parseFloat(element.amount_total)
            }            
          });
          this.arr.purchases = data
          
          this.gridDefColumns()

          this.table.preload = false
          this.prepareExport(data)
        })
        .catch(error => {          
          this.table.preload = false
          this.$awn.alert(Error.showError(error))
        });
      },

      // EXPORT
      prepareExport(data) {             
        this.arr.export = []
        data.forEach(element => {      
          var businessName = ""          
          var suppliersName = ""          
          var suppliersCUIT = ""          
          var suppliersCondFiscal = ""          
          var purchaseCategoryID = 0
          var purchaseCategoryName = ""  

          var typeVoucherName = ""
          const sign = (element.type_voucher && element.type_voucher.type_balance == '-') ? -1 : 1
          const formatAmount = (value) => {
            const amount = (Math.abs(parseFloat(value)) || 0) * sign
            return amount.toFixed(2).replace('.',',')
          }

          if(element.points_sales && element.points_sales.business) {
            businessName = element.points_sales.business.reference
          }
          if(element.supplier) {
            suppliersName = element.supplier.name            
            suppliersCUIT = element.supplier.data_fiscal.documents_number
            suppliersCondFiscal = element.supplier.data_fiscal.fiscal_condition.name
          }       
          if(element.type_voucher) {
            typeVoucherName = element.type_voucher.name                        
          }

          if(element.purchase_category) {
            purchaseCategoryID = element.purchase_category.id
            purchaseCategoryName = element.purchase_category.name                        
          }            

          var arrExport = []
          arrExport["business"] = businessName
          arrExport["date"] = element.date
          arrExport["date_expiration"] = element.date_expiration
          arrExport["date_imputation"] = element.date_imputation
          arrExport["point_sale_imputation"] = element.points_sales.point_sale
          arrExport["typeVoucherName"] = typeVoucherName
          arrExport["letter"] = element.letter
          arrExport["point_sale"] = element.point_sale
          arrExport["number"] = element.number
          arrExport["suppliersName"] = suppliersName
          arrExport["suppliersCUIT"] = suppliersCUIT
          arrExport["suppliersCondFiscal"] = suppliersCondFiscal
          arrExport["purchaseCategoryID"] =  purchaseCategoryID
          arrExport["purchaseCategoryName"] =  purchaseCategoryName

          arrExport['amount_net'] = formatAmount(element.amount_net),

          this.arr.columns.iva_conditions.forEach(elementIva => {            
            arrExport['amount_iva_' + elementIva.label] = formatAmount(element['amount_iva_' + elementIva.label])
          });

          this.arr.columns.perceptions.forEach(elementPerceptions => {                                    
            arrExport['amount_perceptions_' + elementPerceptions.afip_reference] = formatAmount(element['perc_' + elementPerceptions.afip_reference])
          });

          arrExport["amount_total"] = formatAmount(element.amount_total)
          
          this.arr.export.push(arrExport)
        });
      },

      // IVA DIGITAL
      exportFormatIvaDigital() {
        let header = ''        
        let details = ''  
        
        this.arr.purchases.forEach(element => {                                 
          // cantidad de alicuotas
          let arr = []
          let cantAlicuotas = 0
          if(parseFloat(element["amount_iva_0%"])) {
            cantAlicuotas++
            
            arr[3] = [];
            if(!arr[3]["amount_iva"]) {
              arr[3]["amount_iva"] = 0
            }
            if(!arr[3]["amount_net"]) {
              arr[3]["amount_net"] = 0
            }

            arr[3]["amount_iva"] = arr[3]["amount_iva"] + parseFloat(element["amount_iva_0%"])
            arr[3]["amount_net"] = arr[3]["amount_net"] + parseFloat(element["amount_net_0%"])
          }
          if(parseFloat(element["amount_iva_10,50%"])) {
            cantAlicuotas++
            
            arr[4] = [];
            if(!arr[4]["amount_iva"]) {
              arr[4]["amount_iva"] = 0
            }
            if(!arr[4]["amount_net"]) {
              arr[4]["amount_net"] = 0
            }            

            arr[4]["amount_iva"] = arr[4]["amount_iva"] + parseFloat(element["amount_iva_10,50%"])
            arr[4]["amount_net"] = arr[4]["amount_net"] + parseFloat(element["amount_net_10,50%"])
          }
          if(parseFloat(element["amount_iva_21%"])) {
            cantAlicuotas++
            
            arr[5] = [];
            if(!arr[5]["amount_iva"]) {
              arr[5]["amount_iva"] = 0
            }
            if(!arr[5]["amount_net"]) {
              arr[5]["amount_net"] = 0
            }    

            arr[5]["amount_iva"] = arr[5]["amount_iva"] + parseFloat(element["amount_iva_21%"])
            arr[5]["amount_net"] = arr[5]["amount_net"] + parseFloat(element["amount_net_21%"])                        
          }
          if(parseFloat(element["amount_iva_27%"])) {
            cantAlicuotas++
            
            arr[6] = [];
            if(!arr[6]["amount_iva"]) {
              arr[6]["amount_iva"] = 0
            }
            if(!arr[6]["amount_net"]) {
              arr[6]["amount_net"] = 0
            }                

            arr[6]["amount_iva"] = arr[6]["amount_iva"] + parseFloat(element["amount_iva_27%"])
            arr[6]["amount_net"] = arr[6]["amount_net"] + parseFloat(element["amount_net_27%"])                        
          }             

					header += moment(element.date).format('YYYY').toString().padStart(4,'0') + moment(element.date).format('MM').toString().padStart(2,'0') + moment(element.date).format('DD').toString().padStart(2,'0');
          header += element.type_voucher.code_afip.toString().padStart(3,'0');
          header += element.point_sale.toString().padStart(5,'0');
          header += element.number.toString().padStart(20,'0');
          header += "".toString().padStart(16,' ');
          header += element.supplier.data_fiscal.document_type.code_afip.toString().padStart(2,'0');
          header += element.supplier.data_fiscal.documents_number.toString().padStart(20,'0');                    
          header += element.supplier.data_fiscal.business_name.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().slice(0,30).padEnd(30,' ');              
          header += this.formatNumbersForExport(element.amount_total);
          header += this.formatNumbersForExport(element["amount_iva_No Gravado"]);          
          header += this.formatNumbersForExport(element["amount_iva_Exento"]);          
          header += this.formatNumbersForExport(element["perc_IVA"]);
          header += this.formatNumbersForExport(element["perc_NACIONAL"]); 
          header += this.formatNumbersForExport(element["perc_IIBB"]);
          header += this.formatNumbersForExport(element["perc_MUNICIPAL"]); 
          header += this.formatNumbersForExport(0); 
          header += "PES";          
          header += "0001000000";
          header += cantAlicuotas.toString().padStart(1,'0');             
          header += " ";
          header += this.formatNumbersForExport(element["amount_iva"]);
          header += this.formatNumbersForExport(0); // otros tributos
          header += "".padStart(11,'0');
          header += "".padStart(30,' ');
          header += this.formatNumbersForExport(0); 
          header += '\r\n';                
          
          // obtiene total de los detalles de alicuotas           
          arr.forEach((item, key) => {            
            details += element.type_voucher.code_afip.toString().padStart(3,'0');
            details += element.point_sale.toString().padStart(5,'0');
            details += element.number.toString().padStart(20,'0');
            details += element.supplier.data_fiscal.document_type.code_afip.toString().padStart(2,'0');
            details += element.supplier.data_fiscal.documents_number.toString().padStart(20,'0');                                
            details += this.formatNumbersForExport(this.round(item.amount_net));
            details += key.toString().padStart(4,0);
            details += this.formatNumbersForExport(this.round(item.amount_iva));                             
            details += '\r\n';
          })       
        });     
                        
        this.downloadTXT("iva_compra_cabecera.txt", header);                    
        this.downloadTXT("iva_compra_alicuotas.txt", details);                    
      },
      round(number) {        
        return Math.round((parseFloat(number) + Number.EPSILON) * 100) / 100;        
      },
      formatNumbersForExport(value) {
        // Convertir a valor absoluto para siempre usar valores positivos
        let absValue = Math.abs(parseFloat(value));
        let number = absValue.toString().split('.')[0].padStart(13,'0')
        if(absValue.toString().split('.')[1]) {
          number += absValue.toString().split('.')[1].padEnd(2,'0')
        } else {
          number += '00'
        }
        return number
      },      
      downloadTXT(nameFile, content) {        
        const blob = new Blob([content], { type: "text/plain" });

        const enlace = document.createElement("a");
        enlace.href = URL.createObjectURL(blob);
        enlace.download = nameFile;

        enlace.style.display = "none";
        document.body.appendChild(enlace);
        enlace.click();

        document.body.removeChild(enlace);
        URL.revokeObjectURL(enlace.href);
      },  
      
      // GRID
      gridDefColumns() {
        // Definicion de columnas
        let cols1 = [
          { 
            headerName: "Empresa", 
            field: "points_sales.business.reference", 
            width: 100,                         
          },          
          { 
            headerName: "Comprobante", 
            field: "voucher", 
            width: 250, 
            filter: false, 
            sortable: false,            
            cellRenderer: (params) => {
              const item = params.data;

              if (!item || !item.type_voucher || !item.number) return '';
              
              const badgePV =  item.points_sales ? 
              `
                <span class="badge badge-dark"> 
                  ${item.points_sales.point_sale} - ${item.points_sales.name}                    
                </span>
              ` : ``;           
              
              const badgeCategory =  item.purchase_category ? 
              `
                <span class="badge badge-secondary"> 
                  ${item.purchase_category.name}
                </span>
              ` : ``;                         
                            
              return `
                ${badgePV} ${badgeCategory}                
                <br>
                ${item.type_voucher.name} 
                ${item.point_sale.toString().padStart(4,'0')} - ${item.number.toString().padStart(8,'0')}
              `
            }                     
          },
          { 
            headerName: "Fecha", 
            field: "date", 
            width: 120,             
            cellClass: 'text-left', 
            valueFormatter: function(params) { 
              if(!params.value) return ''
              return moment(params.value).format('DD/MM/YYYY') 
            } 
          },     
          { 
            headerName: "Vencimiento", 
            field: "date_expiration", 
            width: 120,             
            cellClass: 'text-left', 
            valueFormatter: function(params) { 
              if(!params.value) return ''
              return moment(params.value).format('DD/MM/YYYY') 
            } 
          }, 
          { 
            headerName: "Imputación", 
            field: "date_imputation", 
            width: 120,             
            cellClass: 'text-left', 
            valueFormatter: function(params) { 
              if(!params.value) return ''
              return moment(params.value).format('DD/MM/YYYY') 
            } 
          },                         
          { 
            headerName: "Proveedor", 
            field: "supplier", 
            width: 250,   
            filter: false, 
            sortable: false,            
            cellStyle: { 
              'line-height': '1.2 !important',              
            },                     
            cellRenderer: (params) => {
              const item = params.data;

              if (!item || !item.supplier) return '';              

              return `                
                  <span style="font-size: 12px;">${item.supplier.data_fiscal.documents_number} / ${item.supplier.data_fiscal.fiscal_condition.name}</span>     
                  <br>               
                  <span class="font-weight-bold">${item.supplier.name}</span>                
              `;
            }              
          },
          { 
            headerName: "Neto", 
            field: "amount_net", 
            width: 110,    
            filter: false, 
            cellStyle: {               
              'text-align': 'right',
              'align-content': 'space-around',
            },            
            cellRenderer: (params) => {
              let item = params.data;
              
              const isSummary = item.summary_amount_net != undefined;
              if(isSummary) {
                item = item.summary_amount_net;
              }

              if (!item || !item.currency) return '';              

              const isNegative = item.type_voucher.type_balance == '+';
              const isPositive = item.type_voucher.type_balance == '-';

              if(isSummary) {
                return `
                  <div style="color:black;">
                    <b>${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_net)}</b>
                  </div>
                `;
              }               
              if(isNegative) {
                return `
                  <div style="color:red;">
                    <b>(${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_net)})</b>
                  </div>
                `;
              }
              if(isPositive) {
                return `
                  <div style="color:green;">
                    <b>${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_net)}</b>
                  </div>
                `;
              }              
            }  
          },          
        ]
        const staticColumns = {
          'points_sales.business.reference': 'business', voucher: 'voucher', date: 'date', date_expiration: 'date_expiration', date_imputation: 'date_imputation', supplier: 'supplier', amount_net: 'amount_net',
        }
        cols1.forEach(column => { column.hide = !this.isIvaColumnVisible(staticColumns[column.field]) })
          
        let childCols2 = []
        for (const key in this.arr.columns.iva_conditions) {          
          const iva = this.arr.columns.iva_conditions[key]

          childCols2.push(
            { 
              headerName: iva.label, 
              field: "amount_iva_" + iva.label, 
              hide: !this.isIvaColumnVisible('iva_' + iva.code),
              width: 110,           
              filter: false,   
              cellStyle: {               
                'text-align': 'right',
                'align-content': 'space-around',
              },            
              cellRenderer: (params) => {                
                let item = params.data;
                
                const isSummary = item["summary_" + iva.label] != undefined;
                if(isSummary) {
                  item = item["summary_" + iva.label];
                }

                if (!item || !item.currency) return '';              
                
                const isNegative = item.type_voucher.type_balance == '+';
                const isPositive = item.type_voucher.type_balance == '-';

                if(isSummary) {
                  return `
                    <div style="color:black;">
                      <b>${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item['amount_iva_' + iva.label])}</b>
                    </div>
                  `;
                } 
                if(isNegative) {
                  return `
                    <div style="color:red;">
                      <b>(${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item['amount_iva_' + iva.label])})</b>
                    </div>
                  `;
                }
                if(isPositive) {
                  return `
                    <div style="color:green;">
                      <b>${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item['amount_iva_' + iva.label])}</b>
                    </div>
                  `;
                }              
              }  
            },                    
          ) 
        }
        let cols2 = [{
          headerName: "Detalle de IVA",
          children: childCols2
        }]

        let childCols3 = []
        for (const key in this.arr.columns.perceptions) {
          const perceptions = this.arr.columns.perceptions[key]

          childCols3.push(
            { 
              headerName: perceptions.afip_reference, 
              field: "perc_" + perceptions.afip_reference, 
              hide: !this.isIvaColumnVisible('perception_' + perceptions.afip_reference),
              width: 110,           
              filter: false,   
              cellStyle: {               
                'text-align': 'right',
                'align-content': 'space-around',
              },            
              cellRenderer: (params) => {                
                let item = params.data;
                
                const isSummary = item["summary_" + perceptions.afip_reference] != undefined;
                if(isSummary) {
                  item = item["summary_" + perceptions.afip_reference];
                }

                if (!item || !item.currency) return '';              
                
                const isNegative = item.type_voucher.type_balance == '+';
                const isPositive = item.type_voucher.type_balance == '-';

                if(isSummary) {
                  return `
                    <div style="color:black;">
                      <b>${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item['perc_' + perceptions.afip_reference])}</b>
                    </div>
                  `;
                } 
                if(isNegative) {
                  return `
                    <div style="color:red;">
                      <b>(${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item['perc_' + perceptions.afip_reference])})</b>
                    </div>
                  `;
                }
                if(isPositive) {
                  return `
                    <div style="color:green;">
                      <b>${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item['perc_' + perceptions.afip_reference])}</b>
                    </div>
                  `;
                }              
              }  
            },                    
          ) 
        }
        let cols3 = [{
          headerName: "Detalle de Percepciones",
          children: childCols3
        }]

        let cols4 = [          
          { 
            headerName: "Total", 
            field: "amount_total", 
            hide: !this.isIvaColumnVisible('amount_total'),
            width: 110, 
            filter: false, 
            cellStyle: {               
              'text-align': 'right',
              'align-content': 'space-around',              
            },   
            cellRenderer: (params) => {
              let item = params.data;
              
              const isSummary = item.summary_amount_total != undefined;
              if(isSummary) {
                item = item.summary_amount_total;
              }

              if (!item || !item.currency) return '';              

              const isNegative = item.type_voucher.type_balance == '+';
              const isPositive = item.type_voucher.type_balance == '-';

              if(isSummary) {
                return `
                  <div style="color:black;">
                    <b>${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_total)}</b>
                  </div>
                `;
              }                        
              if(isNegative) {
                return `
                  <div style="color:red;">
                    <b>(${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_total)})</b>
                  </div>
                `;
              }
              if(isPositive) {
                return `
                  <div style="color:green;">
                    <b>${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_total)}</b>
                  </div>
                `;
              }              
            }  
          },                                   
        ] 

        this.grid.iva.columns = [
          ...cols1,
          ...cols2,
          ...cols3,
          ...cols4,
        ]                   
                
        // Definicion de totales     
        let totales = [{
          summary_amount_net:{
            amount_net: parseFloat(this.totals.total_net),
            currency: { code: this.getCurrency },
            type_voucher: { type_balance: parseFloat(this.totals.total_net) >= 0 ? '+' : '-' },
          },                                       
          summary_amount_total: {
            amount_total: parseFloat(this.totals.total),
            currency: { code: this.getCurrency },
            type_voucher: { type_balance: parseFloat(this.totals.total) >= 0 ? '+' : '-' },
          }
        }]

        for (const key in this.arr.columns.iva_conditions) {          
          const iva = this.arr.columns.iva_conditions[key]

          let importe = parseFloat(iva.total_iva) > 0 ? iva.total_iva : iva.total_net

          if(!totales[0]["summary_"+iva.label]) {
            totales[0]["summary_"+iva.label] = []
            totales[0]["summary_"+iva.label]["amount_iva_"+iva.label] = parseFloat(importe)
            totales[0]["summary_"+iva.label]["currency"] = { code: this.getCurrency }
            totales[0]["summary_"+iva.label]["type_voucher"] = { type_balance: parseFloat(importe) >= 0 ? '+' : '-' }                        
          }         
        }     

        for (const key in this.arr.columns.perceptions) {          
          const perceptions = this.arr.columns.perceptions[key]

          let importe = parseFloat(perceptions.total)

          if(!totales[0]["summary_"+perceptions.afip_reference]) {
            totales[0]["summary_"+perceptions.afip_reference] = []
            totales[0]["summary_"+perceptions.afip_reference]["perc_"+perceptions.afip_reference] = parseFloat(importe)
            totales[0]["summary_"+perceptions.afip_reference]["currency"] = { code: this.getCurrency }
            totales[0]["summary_"+perceptions.afip_reference]["type_voucher"] = { type_balance: parseFloat(importe) >= 0 ? '+' : '-' }                        
          }         
        }        

        this.grid.iva.totales = totales
      }, 
      
      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('reports_purchase', JSON.stringify(this.filters))
      },
      restoreFilterStorage() {
        if(Storage.getValue('reports_purchase')) {
          this.filters = JSON.parse(Storage.getValue('reports_purchase'))
          this.ivaColumnsConfigured = Array.isArray(this.filters.iva_columns)
        }         
        if(!Array.isArray(this.filters.iva_columns)) this.filters.iva_columns = ['business', 'voucher', 'date', 'date_expiration', 'date_imputation', 'supplier', 'amount_net', 'amount_total']
      },         
    }    
  }
</script>
<style scoped>
  .purchase-reports-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 12px;
    border-bottom: 1px solid var(--app-color-border);
    background: var(--app-color-surface-subtle);
  }
  .purchase-reports-toolbar__summary,
  .purchase-reports-toolbar__actions {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .purchase-reports-toolbar__summary {
    color: var(--app-color-text-primary);
    font-size: var(--app-text-sm);
    font-weight: 700;
  }
  .purchase-reports-toolbar__summary > :first-child { color: var(--app-color-primary); font-size: 18px; }
  .purchase-reports-toolbar__summary small {
    padding-left: 8px;
    border-left: 1px solid var(--app-color-border);
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-xs);
    font-weight: 500;
  }
  .purchase-reports-columns-menu { min-width: 220px; padding: 8px 12px; }
  .purchase-reports-columns-menu__title { margin-bottom: 7px; color: var(--app-color-text-secondary); font-size: var(--app-text-xs); font-weight: 700; text-transform: uppercase; }
  @media (max-width: 767.98px) {
    .purchase-reports-toolbar { align-items: flex-start; flex-direction: column; }
    .purchase-reports-toolbar__actions { flex-wrap: wrap; }
  }
</style>
